import { getEnv, getMockAddress } from "#/utils/getEnv";

export const APPLICATION = {
  ID: process.env.REACT_APP_ID.replace(/-/g, "_"),
  NAME: `@${process.env.REACT_APP_ID.replace(/-/g, "_").toUpperCase()}`,
  get BFF_URL() {
    const env = getEnv();
    if (env === "mock") {
      return getMockAddress();
    }

    return window.env.BFF_URL;
  },

  get ENV() {
    return getEnv();
  },
};

export const URL_VITRINE =
  window.env?.ENV !== "prd"
    ? `https://appseguros.${
        window?.env?.ENV ?? "dev"
      }.sicredi.com.br/seguros/vitrine`
    : "https://appseguros.sicredi.com.br/seguros/vitrine";

export { PAGINAS } from "./paginas";

export const HOTJAR = {
  get HJID() {
    return getEnv() === "prd" ? 5241349 : undefined;
  },
  get HJSV() {
    return 6;
  },
};

export * from "./descricaoSeguradoras";
export * from "./ofertas";
export * from "./opcoesBoolean";
export * from "./schemas";
export * from "./statusProposta";

export const URL_CONTATO_COOP = "https://wa.me/+555133584770";
